var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons/message") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch Beta.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/message",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,2 L5,2 C3.34314575,2 2,3.34314575 2,5 L2,21 L2.00598327,21.1136309 C2.09281919,21.9276677 3.1045317,22.3096819 3.70710678,21.7071068 L7.414,18 L19,18 C20.6568542,18 22,16.6568542 22,15 L22,5 C22,3.34314575 20.6568542,2 19,2 Z M5,4 L19,4 C19.5522847,4 20,4.44771525 20,5 L20,15 C20,15.5522847 19.5522847,16 19,16 L7,16 L6.86855602,16.0086724 C6.65185492,16.0374017 6.44917353,16.1366129 6.29289322,16.2928932 L4,18.585 L4,5 C4,4.44771525 4.44771525,4 5,4 Z",
    id: "Path",
    fill: "#3C49A4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.4b2c729b029c1f96adc0b7177a226531.svg";
export { ForwardRef as ReactComponent };